"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.preview.title': 'Knowledge Details',
    'knowledge.preview.edit': 'Edit',
    'knowledge.preview.back': 'Back to List',
    'knowledge.preview.not_found': 'Knowledge entry not found',
    'knowledge.preview.not_provided': 'Not provided',
    'knowledge.preview.no_tags': 'No tags',
    'knowledge.preview.no_file': 'No file attached',
    'knowledge.preview.error.load_failed': 'Failed to load knowledge entry',
    'knowledge.preview.section.basic_info': 'Basic Information',
    'knowledge.preview.section.file_info': 'File Information',
    'knowledge.preview.section.content': 'Content',
    'knowledge.preview.section.used_by_avatars': 'Used by Avatars',
    'knowledge.preview.section.used_by_professions': 'Used by Professions',
    'knowledge.preview.section.errors': 'Errors',
    'knowledge.preview.content_type.text': 'Text',
    'knowledge.preview.content_type.file': 'File',
    'knowledge.preview.content_type.link': 'Link',
    'knowledge.preview.content_type.google-drive': 'Google Drive',
    'knowledge.preview.rag_status.pending': 'Pending',
    'knowledge.preview.rag_status.processing': 'Processing',
    'knowledge.preview.rag_status.completed': 'Completed',
    'knowledge.preview.rag_status.failed': 'Failed',
    'knowledge.preview.rag_status.not_indexed': 'Not Indexed',
    'knowledge.preview.active.yes': 'Yes',
    'knowledge.preview.active.no': 'No',
    'knowledge.preview.no_avatars_using': 'No avatars are currently using this knowledge',
    'knowledge.preview.no_professions_using': 'No professions are currently using this knowledge',
};
